import { render, staticRenderFns } from "./ButacasPlanoGeneral.vue?vue&type=template&id=875b374a&scoped=true"
import script from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
export * from "./ButacasPlanoGeneral.vue?vue&type=script&lang=js"
import style0 from "./ButacasPlanoGeneral.vue?vue&type=style&index=0&id=875b374a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875b374a",
  null
  
)

export default component.exports